import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import deleteIcon from "../../../../images/trash-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboParentButton(props) {
    // Returns Modifier Combo Button in <ModifierComboParentContainer /> inside Product Details Parent Page

    let buttonImageToDisplay;
    let productTextDisplay = props.modifierCategoryDetails.modLinkedToCombo.modName;
    let modifiersToDisplay, modifierDisplayContainer, priceIncMod = "";

    let removeComboButton = <></>

    // Calculate Price
    let modComboPriceInc = parseFloat(props.comboFormData.modComboPriceInc);
    let modGroupsPriceIncCalc = 0;
    props.comboFormData.modComboGroups.forEach((group) => {
        // ⚠ The undefined guard is load-bearing, not defensive padding. A group
        // the customer has not chosen yet has no PriceInc, and parseFloat(undefined)
        // is NaN — which makes the WHOLE combo total render as NaN, not just this
        // line. Keep it.
        if (group.PriceInc === undefined) {
            modGroupsPriceIncCalc += parseFloat(0)
        } else {
            modGroupsPriceIncCalc += parseFloat(group.PriceInc)
        }
    })
    let totalPriceIncCalc = modComboPriceInc + modGroupsPriceIncCalc;
    let totalPriceIncDisplay = CommonUtilities.formatDisplayPrice(totalPriceIncCalc);

    if (!props.comboFormData[`ModComboModCatId${props.modifierCategoryDetails.modCategoryId}`]) {
        buttonImageToDisplay = <span className="wo-combo__mark">
                                    <img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img>
                                </span>
        modifiersToDisplay = <></>
        modifierDisplayContainer = <></>
        priceIncMod = "";
        removeComboButton = <></>
    } else {
        buttonImageToDisplay = <span className="wo-combo__mark wo-combo__mark--on">
                                    <img src={checkIcon} alt="Selected" style={{width: "10px"}}></img>
                                </span>
        removeComboButton = <button type="button" className="wo-combo__remove" title="Remove Combo" onClick={props.handleRemoveModifierComboFromProduct} data-modcombo-modcatid={props.modifierCategoryDetails.modCategoryId}>
                                <img src={deleteIcon} style={{width: "15px"}} alt="Remove icon"></img>
                            </button>
        let keyModListItem = -1;
        modifiersToDisplay = props.comboFormData.modComboGroups.map((mod) => {
            keyModListItem += 1;
            priceIncMod = CommonUtilities.formatDisplayPrice(mod.PriceInc);
            // Return modifiers selected in a list
            return <li key={keyModListItem}>{mod.ModifierName}<span className="ms-2 ps-1">{priceIncMod}</span></li>
        })
        modifierDisplayContainer =
            <ul className="wo-combo__picks">
                {modifiersToDisplay}
            </ul>
    }
    
    /* handleModifierComboSelect and handleRemoveModifierComboFromProduct both
       read data-modcombo-modcatid off event.currentTarget, so the attribute only
       has to sit on the two buttons — inner markup is free to change. */
    return (
        <div className="col-12 wo-combo">
            <button type="button" className="wo-combo__btn" data-modcombo-modcatid={props.modifierCategoryDetails.modCategoryId} onClick={props.handleModifierComboSelect}>
                {buttonImageToDisplay}
                <span className="wo-combo__text">
                    <span className="wo-combo__name">{productTextDisplay}</span>
                    {modifierDisplayContainer}
                </span>
                <span className="wo-combo__price">{totalPriceIncDisplay}</span>
            </button>
            {removeComboButton}
        </div>
    )
}